module.exports = __webpack_public_path__ + "static/media/dota1.f46289dd.gif";